export default {
    obsLink: 'https://ask.gov.sg/obs',
    obsImage: window.location.origin + process.env.REACT_APP_BASE_NAME + 'images/obs-askgov.png'
};